import { ReactNode } from 'react';
import { IPageList } from './pages';
import { IMetaNew } from '../REST';

export enum ServerNotificationEventTypeEnum {
    CARD_IMEI_LOCK_VIOLATION = 'card_imei_lock_violation',
    CARD_SET_THRESHOLD_100_REACHED = 'card_set_threshold_100_reached',
    CARD_SET_THRESHOLD_50_REACHED = 'card_set_threshold_50_reached',
    CARD_SET_THRESHOLD_75_REACHED = 'card_set_threshold_75_reached',
    CARD_SET_TOTAL_THRESHOLD_100_REACHED = 'card_set_total_threshold_100_reached',
    CARD_SET_TOTAL_THRESHOLD_50_REACHED = 'card_set_total_threshold_50_reached',
    CARD_SET_TOTAL_THRESHOLD_75_REACHED = 'card_set_total_threshold_75_reached',
    CARD_THRESHOLD_100_REACHED = 'card_threshold_100_reached',
    CARD_THRESHOLD_50_REACHED = 'card_threshold_50_reached',
    CARD_THRESHOLD_75_REACHED = 'card_threshold_75_reached',
    COMPANY_BALANCE_LIMIT_REACHED = 'company_balance_limit_reached',
    COMPANY_THRESHOLD_HIGH_REACHED = 'company_threshold_high_reached',
    COMPANY_THRESHOLD_MEDIUM_REACHED = 'company_threshold_medium_reached',
    DATA_IMPORT_FAILED = 'data_import_failed',
    DATA_IMPORT_PERFORMED = 'data_import_performed',
    EIM_PROFILE_CREATED = 'eim_profile_created',
    EIM_PROFILE_DESTROYED = 'eim_profile_destroyed',
    EIM_PROFILE_UPDATED = 'eim_profile_updated',
}
export enum ServerNotificationEventDataImportTypeEnum {
    SALES_RATE_LIST_ENTRIES = 'sales_rate_list_entries',
    SUBSCRIBER_IDENTITIES = 'subscriber_identities',
}

type IServerNotificationMainAttributes = {
    created_at?: string;
    read?: boolean;
};
export type IServerNotificationOtherAttributes = IServerNotificationMainAttributes & {
    event?: ServerNotificationEventTypeEnum;
    payload?: any;
};
export type IServerNotificationOldAttributes = IServerNotificationMainAttributes & {
    event: ServerNotificationEventTypeEnum;
    // event:
    //     | ServerNotificationEventTypeEnum.CARD_IMEI_LOCK_VIOLATION
    //     | ServerNotificationEventTypeEnum.CARD_SET_THRESHOLD_100_REACHED
    //     | ServerNotificationEventTypeEnum.CARD_SET_THRESHOLD_50_REACHED
    //     | ServerNotificationEventTypeEnum.CARD_SET_THRESHOLD_75_REACHED
    //     | ServerNotificationEventTypeEnum.CARD_THRESHOLD_100_REACHED
    //     | ServerNotificationEventTypeEnum.CARD_THRESHOLD_50_REACHED
    //     | ServerNotificationEventTypeEnum.CARD_THRESHOLD_75_REACHED
    //     | ServerNotificationEventTypeEnum.COMPANY_BALANCE_LIMIT_REACHED
    //     | ServerNotificationEventTypeEnum.COMPANY_THRESHOLD_HIGH_REACHED
    //     | ServerNotificationEventTypeEnum.COMPANY_THRESHOLD_MEDIUM_REACHED;
    payload: IServerNotificationAPIGETPayload;
};

export type IServerNotificationEimProfilePayload = {
    card?: {
        id: number;
        eid: string;
    };
    operator?: {
        id: number;
        tadig: string;
    };
    subscriber?: {
        id: number;
        msisdn: string;
    };
};

export type IServerNotificationEimProfileAttributes = IServerNotificationMainAttributes & {
    event:
        | ServerNotificationEventTypeEnum.EIM_PROFILE_CREATED
        | ServerNotificationEventTypeEnum.EIM_PROFILE_UPDATED
        | ServerNotificationEventTypeEnum.EIM_PROFILE_DESTROYED;
    payload: IServerNotificationEimProfilePayload;
};

export type IServerNotificationDataImportMainPayload = {
    type: ServerNotificationEventDataImportTypeEnum;
    importTime: string;
};
export type IServerNotificationDataImportPerformedPayload = IServerNotificationDataImportMainPayload & IMessageOptions;
export type IServerNotificationDataImportFailedPayload = IServerNotificationDataImportMainPayload & {
    errors: string | string[];
};

export type IServerNotificationDataImportPerformedAttributes = IServerNotificationMainAttributes & {
    event: ServerNotificationEventTypeEnum.DATA_IMPORT_PERFORMED;
    payload: IServerNotificationDataImportPerformedPayload;
};
export type IServerNotificationDataImportFailedAttributes = IServerNotificationMainAttributes & {
    event: ServerNotificationEventTypeEnum.DATA_IMPORT_FAILED;
    payload: IServerNotificationDataImportFailedPayload;
};
export type IServerNotificationAttributes =
    | IServerNotificationOtherAttributes
    | IServerNotificationOldAttributes
    | IServerNotificationEimProfileAttributes
    | IServerNotificationDataImportPerformedAttributes
    | IServerNotificationDataImportFailedAttributes;

export type IServerNotificationItem = {
    id: string;
    dateAgo: string;
    event?: ServerNotificationEventTypeEnum;
    isRead?: boolean;
    payload?: IServerNotificationAPIGETPayload;
};

export type INotificationStoreItem = {
    key: string;
    message: string;
    description?: ReactNode;
    count?: number;
};

export type IServerNotificationAPIGETPayload = {
    balance?: number | string;
    card?: { id: number; eid?: string };
    card_id?: number;
    card_set_id?: number;
    company_id?: number;
    errors?: string[] | string;
    import_time?: number | string;
    last_imei?: number | string;
    lock_imei?: number | string;
    monthly_cost?: number | string;
    operator?: { id: number; tadig?: string };
    sales_rate_list_id?: string;
    sales_rate_list_name?: string;
    subscriber?: { id: number; msisdn?: string };
    subscriber_id?: number;
    subscriber_name?: string;
    threshold?: number | string;
    type?: ServerNotificationEventDataImportTypeEnum;
};

export type IMessageOptionsCustomLink = {
    customLinkId?: string;
    customLinkListComponent?: IPageList;
    customLinkName?: string;
};
export type IMessageOptions = IMessageOptionsCustomLink & {
    id: string;
    accuracy?: string;
    balance?: number;
    cardId?: number;
    // $cardId$?: number;
    cardSetId?: number;
    cid?: string;
    companyId?: number;
    currency?: string;
    eid?: string;
    importTime?: number;
    lac?: string;
    lastImei?: string;
    lockImei?: string;
    monthlyCost?: number;
    msisdn?: string;
    operatorId?: number;
    salesRateListId?: string;
    salesRateListName?: string;
    subscriberId?: number;
    subscriberName?: number;
    tadig?: string;
    threshold?: number;
    type?: string;
    x?: string;
    y?: string;
};

export type IServerNotificationGETCountAPI = {
    read_count?: number;
    unread_count?: number;
};
export type IServerNotificationAPIGETDataItem = {
    id?: string;
    type?: 'company_notification';
    attributes?: IServerNotificationAttributes;
};

export type IServerNotificationAPIGETItemNew = {
    id?: number;
    event?: ServerNotificationEventTypeEnum;
    read?: boolean;
    payload?: IServerNotificationAPIGETPayload;
    created_at?: string;
};
export type IServerNotificationAPIGETNew = {
    company_notifications?: IServerNotificationAPIGETItemNew[];
    meta?: IMetaNew;
};

export enum NotificationType {
    SUCCESS = 'success',
    ERROR = 'error',
    INFO = 'info',
    WARNING = 'warning',
}
